export default __webpack_public_path__ + "static/mobile-chckup-vs-allydvm-7b04f5da49b5514a50388628ad240330.png";